import React, { createContext, useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

const TableStateContext = createContext();

export const useTableState = () => {
  const context = useContext(TableStateContext);
  if (!context) {
    throw new Error("useTableState must be used within a TableStateProvider");
  }
  return context;
};

export const TableStateProvider = ({ children }) => {
  const [alteracoes, setAlteracoes] = useState([]);
  const [checkboxAlteracoes, setCheckboxAlteracoes] = useState([]);

  const addAlteracao = useCallback((alteracao) => {
    setAlteracoes((prev) => {
      const existing = prev.findIndex((item) => item.id === alteracao.id);
      if (existing !== -1) {
        const updated = [...prev];
        updated[existing] = alteracao;
        return updated;
      }
      return [...prev, alteracao];
    });
  }, []);

  const removeAlteracao = useCallback((id) => {
    setAlteracoes((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const toggleCheckboxAlteracao = useCallback((alteracao) => {
    setCheckboxAlteracoes((prev) => {
      const existing = prev.findIndex((item) => item.id === alteracao.id);
      if (existing !== -1) {
        return prev.filter((item) => item.id !== alteracao.id);
      }
      return [...prev, alteracao];
    });
  }, []);

  const setAllCheckboxes = useCallback((ids) => {
    setCheckboxAlteracoes(ids);
  }, []);

  const clearAll = useCallback(() => {
    setAlteracoes([]);
    setCheckboxAlteracoes([]);
  }, []);

  const isFormDirty = alteracoes.length > 0 || checkboxAlteracoes.length > 0;

  const contextValue = React.useMemo(
    () => ({
      alteracoes,
      checkboxAlteracoes,
      isFormDirty,
      addAlteracao,
      removeAlteracao,
      toggleCheckboxAlteracao,
      clearAll,
      setAllCheckboxes,
    }),
    [
      alteracoes,
      checkboxAlteracoes,
      isFormDirty,
      addAlteracao,
      removeAlteracao,
      toggleCheckboxAlteracao,
      clearAll,
      setAllCheckboxes,
    ]
  );

  return <TableStateContext.Provider value={contextValue}>{children}</TableStateContext.Provider>;
};

TableStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
